<template>
    <button type="button" :class="classes" :disabled="disabled">
        <slot></slot>
    </button>
</template>

<script>
export default {
    name: "AppButton",
    emits: ['keydown:enter'],
    props: {
        color: {
            type: String,
            required: true
        },
        size: {
            type: String,
            default: 'md'
        },
        icon: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        classes() {
            let classes = ['btn', `btn-${this.size}`];

            let colorClass;

            if (['danger', 'light'].includes(this.color)) {
                colorClass = `btn-${this.color}`
            } else {
                colorClass = `bg-${this.color}`
            }

            classes.push(colorClass)

            if (this.icon) {
                classes.push('btn-icon');
            }
            return classes;
        }
    },
}
</script>

<style scoped>
</style>
